// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file chatprompts/chatprompts.proto (package lvdr.v2.chatprompts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chatprompts/chatprompts.proto.
 */
export const file_chatprompts_chatprompts: GenFile = /*@__PURE__*/
  fileDesc("Ch1jaGF0cHJvbXB0cy9jaGF0cHJvbXB0cy5wcm90bxITbHZkci52Mi5jaGF0cHJvbXB0cyKMAQoKQ2hhdFByb21wdBIKCgJpZBgBIAEoCRIQCghuYW1lX2tleRgCIAEoCRITCgtzdW1tYXJ5X2tleRgDIAEoCRIQCghib2R5X2tleRgEIAEoCRIQCghjYXRlZ29yeRgFIAEoCRISCgpjYXBhYmlsaXR5GAYgAygJEhMKC21hdGNoX2hpbnRzGAcgAygJIioKFkxpc3RDaGF0UHJvbXB0c1JlcXVlc3QSEAoIY2F0ZWdvcnkYASABKAkiSwoXTGlzdENoYXRQcm9tcHRzUmVzcG9uc2USMAoHcHJvbXB0cxgBIAMoCzIfLmx2ZHIudjIuY2hhdHByb21wdHMuQ2hhdFByb21wdEIsWipnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvY2hhdHByb21wdHNiBnByb3RvMw");

/**
 * A shipped starter prompt. Every user-visible field is an i18n KEY, never
 * prose: the catalog is translated in web/messages/*.json, and putting English
 * text on the wire would make the German client render English.
 *
 * @generated from message lvdr.v2.chatprompts.ChatPrompt
 */
export type ChatPrompt = Message<"lvdr.v2.chatprompts.ChatPrompt"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name_key = 2;
   */
  nameKey: string;

  /**
   * @generated from field: string summary_key = 3;
   */
  summaryKey: string;

  /**
   * @generated from field: string body_key = 4;
   */
  bodyKey: string;

  /**
   * research | knowledge | writing | analysis | workflow
   *
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * what of OURS it exercises
   *
   * @generated from field: repeated string capability = 6;
   */
  capability: string[];

  /**
   * lexical hints; consumed by CHAT-38's router
   *
   * @generated from field: repeated string match_hints = 7;
   */
  matchHints: string[];
};

/**
 * Describes the message lvdr.v2.chatprompts.ChatPrompt.
 * Use `create(ChatPromptSchema)` to create a new message.
 */
export const ChatPromptSchema: GenMessage<ChatPrompt> = /*@__PURE__*/
  messageDesc(file_chatprompts_chatprompts, 0);

/**
 * @generated from message lvdr.v2.chatprompts.ListChatPromptsRequest
 */
export type ListChatPromptsRequest = Message<"lvdr.v2.chatprompts.ListChatPromptsRequest"> & {
  /**
   * empty = all
   *
   * @generated from field: string category = 1;
   */
  category: string;
};

/**
 * Describes the message lvdr.v2.chatprompts.ListChatPromptsRequest.
 * Use `create(ListChatPromptsRequestSchema)` to create a new message.
 */
export const ListChatPromptsRequestSchema: GenMessage<ListChatPromptsRequest> = /*@__PURE__*/
  messageDesc(file_chatprompts_chatprompts, 1);

/**
 * @generated from message lvdr.v2.chatprompts.ListChatPromptsResponse
 */
export type ListChatPromptsResponse = Message<"lvdr.v2.chatprompts.ListChatPromptsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.chatprompts.ChatPrompt prompts = 1;
   */
  prompts: ChatPrompt[];
};

/**
 * Describes the message lvdr.v2.chatprompts.ListChatPromptsResponse.
 * Use `create(ListChatPromptsResponseSchema)` to create a new message.
 */
export const ListChatPromptsResponseSchema: GenMessage<ListChatPromptsResponse> = /*@__PURE__*/
  messageDesc(file_chatprompts_chatprompts, 2);

